import { styled } from '@linaria/react';

const ActionButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  color: inherit;

  svg {
    display: block;
  }

  &:focus-visible {
    outline-color: var(--color-primary);
  }
`;

export default ActionButton;
